import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { FormWizardTemplate } from 'src/app/models/form-wizard-template.model';
import { LoginDetails } from 'src/app/models/settings/login-details.model';
import { ContactService } from 'src/app/services/contact.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  private contactWizard?: FormWizardTemplate;
  private contactSuccessMessage?: string;

  public contactSuccessful = false;
  public formValues: any = {};

  constructor(
    private contactService: ContactService,
    private sessionService: SessionService) { }

  ngOnInit(): void {
    setTimeout(() => this.loadContactUsDetails(), 0);
  }

  private loadContactUsDetails(): void {
    this.sessionService.showLoading();

    this.contactService.getContactUsDetails().subscribe({
      next: (result) => this.loadContactUsDetailsOk(result),
      error: (error) => this.loadContactUsDetailsError(error.error)
    });
  }

  private loadContactUsDetailsOk(result: LoginDetails) {
    this.contactWizard = this.sessionService.getContactUsFormWizard(result.contactUs.contactInfo);
    this.formValues.referenceId = this.sessionService.getUserId();
    this.contactSuccessMessage = 'Message has been successfully sent.';

    this.sessionService.hideLoading();
  }

  private loadContactUsDetailsError(error: any) {
    this.sessionService.hideLoading();

    this.sessionService.showErrorDialog('Error loading contact details. Please refresh the page to try again.');
  }

  public getSuccessMessage(): string {
    return this.contactSuccessMessage ?? '';
  }

  public isSuccessVisible(): boolean {
    return this.contactSuccessful;
  }

  public isWizardVisible(): boolean {
    return !_.isNil(this.contactWizard) && !this.contactSuccessful;
  }

  public getContactFormWizard(): FormWizardTemplate {
    return this.contactWizard ?? new FormWizardTemplate();
  }

  public formWizardActionHandler(action: string): void {
    switch (action) {
      case 'complete':
        this.handleFormSubmit();
        break;
    }
  }

  private handleFormSubmit(): void {
    this.postContactUsMessage();
  }

  private postContactUsMessage(): void {
    this.sessionService.showProcessing();

    this.contactService.postContactRequest(this.formValues).subscribe({
      next: () => this.postContactUsMessageOk(),
      error: (error) => this.postContactUsMessageError(error.error)
    });
  }

  private postContactUsMessageOk(): void {
    this.contactSuccessful = true

    this.sessionService.hideProcessing();
  }

  private postContactUsMessageError(error: any): void {
    this.sessionService.hideProcessing();
    this.sessionService.showErrorDialog('Error sending message. Please try submitting the message again.');
  }
}
